module.exports = __webpack_public_path__ + "img/zhenduixingjianyi_jpg_smzlpg.e21a5bf1.png";